var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12.5H25V25H12.5V12.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 0V37.5H0V0H37.5ZM31.25 6.25H6.25V31.25H31.25V6.25ZM25 75H12.5V87.5H25V75Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 62.5V100H0V62.5H37.5ZM6.25 68.75V93.75H31.25V68.75H6.25ZM75 12.5H87.5V25H75V12.5Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 0V37.5H100V0H62.5ZM93.75 6.25V31.25H68.75V6.25H93.75ZM50 6.25V0H56.25V12.5H50V25H43.75V6.25H50ZM50 37.5V25H56.25V37.5H50ZM37.5 50V43.75H43.75V37.5H50V50H56.25V43.75H87.5V50H62.5V56.25H43.75V50H37.5ZM37.5 50V56.25H12.5V50H6.25V56.25H0V43.75H18.75V50H37.5ZM100 56.25H93.75V43.75H100V56.25ZM93.75 56.25H87.5V68.75H100V62.5H93.75V56.25ZM68.75 56.25H81.25V62.5H75V68.75H68.75V56.25ZM81.25 75V68.75H75V75H68.75V81.25H56.25V87.5H75V75H81.25ZM81.25 75H100V81.25H87.5V87.5H81.25V75ZM56.25 68.75V75H62.5V62.5H43.75V68.75H56.25Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 75H50V93.75H75V100H43.75V75ZM100 87.5V100H81.25V93.75H93.75V87.5H100Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qrCode.0104f912530ac5bff4863f7019676dce.svg";
export { ForwardRef as ReactComponent };